import React from 'react'
import Style from './CompleteShopping.module.css'
import Button from '../Button/Button'
const CompleteShopping = (props) => {

    return (
        <div className={Style.TotalPrice}> 
            <Button ClassBtn={'buy'} Value={'نهایی کردن خرید'} ClickHandler={props.finalize}/>
        </div>
    )
} 

export default CompleteShopping
 